module.exports = __webpack_public_path__ + "img/1A_Logo_light.42f6b322.png";